module.exports = require(`./dist/react-pixi.module${process.env.NODE_ENV === 'development' ? '-dev' : ''}`)



//////////////////
// WEBPACK FOOTER
// ./node_modules/@inlet/react-pixi/module.js
// module id = 19
// module chunks = 0